import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { ArticleContext } from '../Context';

export const StyledText = ({
	id,
	text,
	text_lang,
	expandfullwidth,
	bleed,
	dropcap,
	component,
}) => {
	let { lang } = useContext(ArticleContext);
	let content = text;
	if (lang && text_lang?.[lang]) {
		content = text_lang[lang];
	}

	return (
		<Text
			id={id}
			bleed={bleed === 'on'}
			text={content}
			dropcap={dropcap === 'on'}
			expandFullWidth={expandfullwidth === 'on'}
			type={component}
		/>
	);
};

StyledText.propTypes = {
	id: PropTypes.string,
	text: PropTypes.string,
	column: PropTypes.bool,
	text_lang: PropTypes.object,
	expandfullwidth: PropTypes.string,
	bleed: PropTypes.string,
	dropcap: PropTypes.string,
	columnStyle: PropTypes.object,
	component: PropTypes.oneOf([
		'headline',
		'title',
		'subtitle',
		'intro',
		'body',
		'crosshead',
		'byline',
		'blockquote',
		'footer',
		'text1',
		'text2',
		'text3',
		'text4',
		'text5',
		'text6',
		'text7',
		'text8',
		'text9',
		'text10',
	]),
};

StyledText.defaultProps = {
	column: false,
	columnStyle: null,
};

export const Text = ({ id, bleed, text, expandFullWidth, type, dropcap }) => {
	const style = {};
	if (expandFullWidth) {
		style.minWidth = '100%';
		style.width = '100%';
	}

	if(text === '<p></p>') {
		return null;
	}

	return (
		<div
			id={id}
			style={style}
			className={`${type}${bleed ? ' bleed' : ''}${
				dropcap ? ' dropcap' : ''
			}`}
			dangerouslySetInnerHTML={{ __html: text }}
		/>
	);
};

Text.propTypes = {
	id: PropTypes.string,
	bleed: PropTypes.bool,
	text: PropTypes.PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	expandFullWidth: PropTypes.bool,
	css: PropTypes.string,
	style: PropTypes.object,
	container: PropTypes.object,
	dropcap: PropTypes.bool,
	type: PropTypes.oneOf([
		'headline',
		'title',
		'subtitle',
		'intro',
		'body',
		'crosshead',
		'byline',
		'blockquote',
		'footer',
		'text1',
		'text2',
		'text3',
		'text4',
		'text5',
		'text6',
		'text7',
		'text8',
		'text9',
		'text10',
	]),
};

Text.defaultProps = {
	bleed: false,
	expandFullWidth: false,
	css: '',
	style: {},
	dropcap: false,
};
